import * as React from "react";
const Check = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.75 15.25 7 12.5 6 13.499 9.75 17.25 18 8.999 17 8z" }));
Check.displayName = "Check";
var Check_default = Check;
export {
  Check_default as default
};
